<app-page-header [heading]="'Purchase Report'" [icon]="'fa-history'" style="height:100px;"></app-page-header>
<div *ngIf="user_rights.ADD == '1'" class="page-panel">
  <div class="clearfix"></div>
  <div class="row">
    <div class="form-group col-lg-3">
      <label>From</label>
      <input (ngModelChange)="fromdate = $event" [max]="getToday()" [ngModel]="fromdate | date:'yyyy-MM-dd'"
             class="form-control " id="date" name="date" type="date">

    </div>
    <div class="form-group col-lg-3">
      <label>To</label>
      <input (ngModelChange)="todate = $event" [max]="getToday()" [ngModel]="todate | date:'yyyy-MM-dd'"
             class="form-control " id="todate" name="todate" type="date">
    </div>
    <div class="form-group col-lg-4">
      <label>Supplier Name</label>
      <ngx-select-dropdown (change)="getVendor($event);listPurchaseReport();" [(ngModel)]="vendor_data"
                           [config]="utils.dropConfig({displayKey: 'VENDOR_NAME',placeholder: 'Select Supplier',searchOnKey: 'VENDOR_NAME'})"
                           [multiple]="false"
                           [options]="vendor_options" class="form-control  select-dropdown"
                           name="vendor"></ngx-select-dropdown>
    </div>
    <div class="form-group col-lg-2">
      <label></label><br>
      <button (click)="listPurchaseReport();" class="btn btn-info btn-sm ng-star-inserted" type="button">&nbsp;Search&nbsp;</button>
    </div>
    <div class="clearfix"></div>
    <div class="clearfix"></div>
    <div class="form-group col-lg-8"></div>
    <div class="form-group col-lg-4 ">
      <div class="input-group ">
        <input [(ngModel)]="term" class="form-control" id="typeahead-http" name="search_text" placeholder=""
               style="height:31px" type="text">
        <div class="input-group-append">
                    <span class="input-group-text" style="height:31px;padding:7px">
                        <i class="fa fa-search"></i>
                    </span>
        </div>
      </div>
    </div>
    <div class="text-right col-lg-12 pull-right">
      <button (click)="ExportToExcel()" *ngIf="(purchase_data | json) != '[]'"
              class="btn btn-info btn-sm"
              title="Export as XLSX">Export to XLSX&nbsp;<i class="fa fa-file-excel-o"></i></button>&nbsp;
      <app-report-pdf *ngIf="(purchase_data | json) != '[]'" targetId="printReport" fileName="Purchase_Report.pdf" titleName="PURCHASE REPORT"></app-report-pdf>
    </div>
    <div class="clearfix"></div>
    <div class="col-12" id="printReport">
      <table #table class="table tbl table-bordered" style="background-color: #f3f8fd">
        <thead>
          <tr class="text-center">
            <th width="1%">Sl</th>
            <th width="10%">GRN No.</th>
            <th width="10%">Invoice Date</th>
            <th>Invoice Number</th>
            <th>Supplier Name</th>
            <th>Item</th>
            <th width="7%">Quantity</th>
            <th width="10%">Amount</th>
          </tr>
          <tr *ngIf="(purchase_data | json) == '[]'">
            <td class="text-center" colspan="7">No data to list</td>
          </tr>
        </thead>
        <tbody>
        <tr *ngFor="let purchase of purchase_data| filter:term;let i=index">
          <td class="text-center">{{ i + 1 }}</td>
          <td class="text-center">{{ purchase.GRN_NUMBER }}</td>
          <td class="text-center">{{ purchase.INVOICE_DATE }}</td>
          <td class="text-center">{{ purchase.INVOICE_NUMBER }}</td>
          <td>{{ purchase.VENDOR_NAME }}</td>
          <td>{{ purchase.CODE }} - {{ purchase.ITEM }}</td>
          <td class="text-right">{{ purchase.QUANTITY }}</td>
          <td class="text-right">{{ purchase.AMOUNT }}</td>
        </tr>
        </tbody>
        <tfoot *ngIf="total_amount > 0">
        <tr>
          <th colspan="7" class="text-right">Total Amount</th>
          <th class="text-right">{{ total_amount | number : '1.2-2' }}</th>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</div>